import { render } from "./OrdersCollectionDashboard.html?vue&type=template&id=511d4a5c&scoped=true"
import script from "./OrdersCollectionDashboard.js?vue&type=script&lang=js"
export * from "./OrdersCollectionDashboard.js?vue&type=script&lang=js"

import "./OrdersCollectionDashboard.css?vue&type=style&index=0&id=511d4a5c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511d4a5c"]])

export default __exports__